export default {
  tab: 'Watched and Followed Positions',
  searchBox: {
    placeholder: 'Search by location',
    enterToSearch: 'Press ⏎ to search',
  },
  allStatus: 'All Types',
  watching: 'Watching',
  following: 'Following',
  none: 'None',
  searchRecruiters: 'Search by recruiter',
  recruiters: 'Recruiters',
  recruiter: 'Recruiter',
  selectOption: 'Select Type',
  followed: 'Followed',
  watched: 'Watched',
};
